const defaults = {
  apiUrl: null,
  handleBadStatusResponse: response => response,
  firstCatch: err => {
    throw err
  },
  getToken: () => null
}

export default spec => (query, variables = null) => {
  const opts = Object.assign({}, defaults, spec)
  const token = opts.getToken()
  const encodedQuery = encodeURIComponent(query.trim())
  const encodedVars = variables
    ? `&variables=${encodeURIComponent(JSON.stringify(variables))}`
    : ''
  const tokenQuery = token ? `&token=${token}` : ''

  return fetch(
    `${opts.apiUrl}/graphql?query=${encodedQuery}${encodedVars}${tokenQuery}`,
    {
      method: 'post'
    }
  )
    .then(response => {
      if (response.status >= 400) {
        if (opts.handleBadStatusResponse) {
          return opts.handleBadStatusResponse(response)
        }
        throw new Error(response.statusText)
      }
      if (response.status === 204) {
        return
      }
      return response.json()
    })
    .then(parsed => {
      if (parsed.errors) {
        throw parsed.errors
      }
      return parsed
    })
    .catch(opts.firstCatch)
}
